import { render, staticRenderFns } from "./reviewWidgetAll.vue?vue&type=template&id=bf450656&"
import script from "./reviewWidgetAll.vue?vue&type=script&lang=js&"
export * from "./reviewWidgetAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vasile_cyt/Documents/plentyDevTool/25996/21/reviewWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf450656')) {
      api.createRecord('bf450656', component.options)
    } else {
      api.reload('bf450656', component.options)
    }
    module.hot.accept("./reviewWidgetAll.vue?vue&type=template&id=bf450656&", function () {
      api.rerender('bf450656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/reviewWidgetAll.vue"
export default component.exports